import OnboardingContainer from '@forwardflow/components/OnboardingContainer'

const ErrorFound = () => {
   return (
      <OnboardingContainer avatar={false}>
         <div className="flex flex-col items-center justify-center mt-64">
            <h1 className="text-4xl font-bold">Ah! Something Went Wrong</h1>
            <p className="mt-2">
               Looks like this page having some issues. Return to
               the{' '}
               <a href="/dashboard" className="text-primary">
                  dashboard.
               </a>
            </p>
         </div>
      </OnboardingContainer>
   )
}

export default ErrorFound
